<template>
  <div class="bottomInfo">
    <div class="rightFixed">
      <!-- 客服-->
      <el-tooltip class="item" effect="dark" :content="$t('home').Onlinecustomerservice" placement="left">
        <div class="item" @click="goServe">
          <svg-icon class-name="svgs" icon-class="service" />
        </div>
      </el-tooltip>
      <!-- 下载-->
      <el-popover placement="left" width="220" trigger="hover" popper-class="elpopper">
        <div class="qrcodeInfo">
          <qrcode-vue :value="qrcodeUrl" :size="160" level="H" class="qrimg"></qrcode-vue>
          <div class="tips">{{ $t('home').Scandownload }} {{ platformName }} App</div>
        </div>
        <div class="item" slot="reference">
          <svg-icon class-name="svgs" icon-class="down" />
        </div>
      </el-popover>
      <!-- 帮助中心-->
      <el-tooltip class="item" effect="dark" :content="$t('common').helpcenter" placement="left">
        <div class="item" @click="$router.push({ name: 'About' })">
          <svg-icon class-name="svgs" icon-class="help" />
        </div>
      </el-tooltip>
    </div>
    <!-- <div class="toTop" v-show="showButton" @click="scrollToTop">
      <svg-icon class-name="svgs" icon-class="gotop" />
    </div> -->
    <div class="info">
      <div class="topinfo">
        <!-- logo -->
        <div class="logoinfo">
          <div class="logo">{{ platformName }}</div>
          <div class="tips">Exchange for a better future</div>
        </div>
        <!-- 产品 -->
        <div class="item">
          <div class="title">{{ $t('home').product }}</div>
          <div class="lable" @click="toTrade(1)">{{ $t('public').USDTcontract }}</div>
          <!-- <div class="lable" @click="toTrade(2)">{{ $t('public').Fiatcurrencycontract }}</div> -->
          <div class="lable" @click="toTrade(3)">{{ $t('public').spot }}</div>
          <div class="lable" @click="toTrade(4)">{{ $t('public').secondContract }}</div>
          <div class="lable" @click="$router.push({ name: 'Finance' })" v-if="!$store.state.isSim">{{ $t('tabBar').heel }}</div>
        </div>
        <!-- 服务 -->
        <div class="item">
          <div class="title">{{ $t('home').service }}</div>
          <!-- <div class="lable" @click="$router.push({ name: 'Share' })">{{ $t('user').Invitefriends }}</div> -->
          <div class="lable" @click="$router.push({ name: 'Market' })">{{ $t('market').market }}</div>
        </div>
        <!-- 指南 -->
        <div class="item">
          <div class="title">{{ $t('home').guide }}</div>
          <div class="lable" @click="goServe">{{ $t('user').helpcenter }}</div>
          <!-- <div class="lable" @click="$router.push({ name: 'Notice' })">{{ $t('common').Notice }}</div> -->
        </div>
        <!-- 关于我们 -->
        <div class="item">
          <div class="title">{{ $t('about').title }}</div>
          <div class="lable" @click="$router.push({ name: 'About' })">{{ $t('about').about }}{{ platformName }}</div>
          <!-- <div class="lable" @click="goWhite">{{ $t('about').whitePaper }}</div> -->
        </div>
        <!-- 协议声明 -->
        <div class="item">
          <div class="title">{{ $t('home').agreedannouncement }}</div>
          <div class="lable" @click="goContent(5, '')">{{ $t('about').Termofservice }}</div>
          <div class="lable" @click="goContent(0, $t('about').PrivacyAgreement)">{{ $t('about').PrivacyAgreement }}
          </div>
          <div class="lable" @click="goContent(6, '')">{{ $t('about').Riskstatement }}</div>
        </div>
        <!-- 客户服务 -->
        <div class="item">
          <div class="title">{{ $t('home').customerservice }}</div>
          <div class="lable" @click="goServe">{{ $t('home').Onlinecustomerservice }}</div>
        </div>
      </div>
      <!-- 风险提示 -->
      <div class="txt"> {{ $t('home').Riskstatement }}</div>
      <div class="txt">
        © 2011-2026 {{ platformName }}.com. All rights reserved
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EventBus } from '@/utils/event-bus'
import systemApi from '@/api/system'
import userApi from '@/api/user'
import { Token } from '@/utils/mm'
import QrcodeVue from 'qrcode.vue'
export default {
  name: 'Bottom',
  components: {
    QrcodeVue
  },
  data() {
    return {
      platformName: localStorage.getItem('platformName'),
      showButton: false, // 是否显示按钮
      qrcodeUrl: '',
    }
  },
  computed: {
    ...mapGetters(['basicConfig', 'lang', 'connection']),
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.getConfig()
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 获取配置
    async getConfig() {
      const res = await systemApi.getConfig()
      this.qrcodeUrl = res.systemSetting.qrcodeUrl
    },
    handleScroll() {
      this.showButton = window.scrollY > window.innerHeight; // 滚动超过1页才显示
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" }); // 平滑滚动到顶部
    },
    // 客服
    async goServe() {
      // const res = await systemApi.getConfig()
      // location.href = res.systemSetting.serviceUrl
      if (Token.get()) {
        const res = await userApi.getMemberInfo()
        const encodedData = JSON.stringify({ name: res.user.memberId, email: res.user.memberName });
        location.href = 'chatlinkonline.html?metadata=' + encodedData
      } else {
        location.href = 'chatlinkonline.html'
      }
    },
    goWhite() {
      window.open('/GlobalEx white paper.pdf');
    },
    // 跳转内容
    async goContent(type, title) {
      const res = await systemApi.getContentList({ type: type })
      this.$router.push({ name: 'Detail', query: { Name: title, id: res.rows[0].contentLocalizationId } })
    },
    //跳转交易
    toTrade(val) {
      if (this.$route.name == 'Trade') {
        EventBus.$emit('tradeType', val)
        return
      }
      if (val)
        this.$router.push({ name: 'Trade', query: { type: val } })
      else
        this.$router.push({ name: 'Trade' })
    },
  }
}
</script>

<style lang="less" scoped>
.bottomInfo {
  padding-top: 50px;
  width: 100%;
  background: var(--info_color);
  .rightFixed {
    position: fixed;
    bottom: 60px;
    right: 30px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    z-index: 1000;

    .item {
      width: 40px;
      height: 40px;
      background: var(--primary_color);
      border-radius: 50%;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      .svgs {
        width: 18px;
        height: 18px;
        color: #fff;
      }
    }

    .item:hover {
      opacity: 0.8;
    }
  }

  .toTop {
    position: fixed;
    bottom: 30px;
    right: 30px;
    width: 40px;
    height: 40px;
    background: var(--primary_color);
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    .svgs {
      width: 20px;
      height: 20px;
      color: #fff;
    }
  }

  .toTop:hover {
    opacity: 0.8;
  }

  .info {
    margin: 0 auto;
    max-width: 1280px;

    .topinfo {
      display: flex;
      justify-content: space-between;
      margin-bottom: 50px;

      .logoinfo {
        .logo {
          font-size: 27px;
          font-weight: bold;
          color: var(--primary_color);
        }

        .tips {
          margin-top: 20px;
          font-size: 14px;
          color: var(--ntext_color);
        }
      }

      .item {
        .title {
          font-size: 16px;
          font-weight: bold;
          color: var(--text_color);
        }

        .lable {
          margin-top: 20px;
          font-size: 14px;
          color: var(--ntext_color);
        }

        .lable:hover {
          color: var(--primary_color);
        }
      }
    }

    .txt {
      padding: 20px 0;
      border-top: 1px solid var(--info_color);
      font-size: 12px;
      line-height: 20px;
      color: var(--ntext_color);
    }
  }
}
//下载
.qrcodeInfo {
  padding: 20px 20px 0 20px;

  .qrimg {
    width: 180px;
    height: 180px;
    padding: 10px;
    background: #fff;
    border-radius: 10px;
  }

  .tips {
    margin: 10px 0 20px 0;
    text-align: center;
    font-size: 14px;
    color: #a3a3a5;
  }
}
</style>
